<template>
  <div class="step-select-otp">
    <p class="step-desc text-center">
      Vui lòng chọn hình thức xác thực để hoàn tất quá trình xác nhận.
    </p>

    <!-- Option: Email -->
    <label v-if="email" class="auth-option w-100 mb-3">
      <input type="radio" name="authMethod" class="d-none" value="EMAIL" v-model="selectedMethod" />
      <div class="option-content d-flex align-items-center p-3 rounded-3">
        <div class="auth-radio flex-shrink-0"></div>
        <div
          class="auth-icon-wrapper flex-shrink-0 rounded-circle d-flex justify-content-center align-items-center mx-3"
        >
          <img src="@/assets/img/nganluong/icon-mail.svg" alt="Email" />
        </div>
        <div class="text-start">
          <div class="fw-bold text-dark" style="font-size: 15px">Gửi qua Email</div>
          <div class="text-muted" style="font-size: 14px; font-weight: 500">
            {{ email | maskEmail }}
          </div>
        </div>
      </div>
    </label>

    <!-- Option: Zalo -->
    <label v-if="mobile && !isHiddenZns" class="auth-option w-100 mb-3">
      <input type="radio" name="authMethod" class="d-none" value="ZNS" v-model="selectedMethod" />
      <div class="option-content d-flex align-items-center p-3 rounded-3">
        <div class="auth-radio flex-shrink-0"></div>
        <div
          class="auth-icon-wrapper flex-shrink-0 rounded-circle d-flex justify-content-center align-items-center mx-3"
        >
          <img src="@/assets/img/nganluong/icon-zalo.svg" alt="Zalo" />
        </div>
        <div class="text-start">
          <div class="fw-bold text-dark" style="font-size: 15px">Gửi qua Zalo</div>
          <div class="text-muted" style="font-size: 14px; font-weight: 500">
            {{ maskedPhone }}
          </div>
        </div>
      </div>
    </label>

    <!-- Option: SMS -->
    <label v-if="mobile" class="auth-option w-100 mb-3">
      <input type="radio" name="authMethod" class="d-none" value="SMS" v-model="selectedMethod" />
      <div class="option-content d-flex align-items-center p-3 rounded-3">
        <div class="auth-radio flex-shrink-0"></div>
        <div
          class="auth-icon-wrapper flex-shrink-0 rounded-circle d-flex justify-content-center align-items-center mx-3"
        >
          <img src="@/assets/img/nganluong/icon-phone.svg" alt="Phone" />
        </div>
        <div class="text-start">
          <div class="fw-bold text-dark" style="font-size: 15px">Gửi qua tin nhắn SMS</div>
          <div class="text-muted" style="font-size: 14px; font-weight: 500">
            {{ maskedPhone }}
          </div>
        </div>
      </div>
    </label>

    <!-- Fake footer -->
    <div class="popup-footer">
      <b-button
        variant="primary"
        class="footer-btn"
        :disabled="!selectedMethod"
        @click="handleContinue"
      >
        Tiếp tục
      </b-button>
    </div>
  </div>
</template>

<script>
  import { appendixContractNlGetOTP } from '@/services/contract.service'

  export default {
    name: 'StepSelectOtp',
    props: {
      id: { type: String, default: '' },
      mobile: { type: String, default: '' },
      email: { type: String, default: '' },
      token: { type: String, default: '' },
      updateShowLoading: { type: Function, required: true },
    },
    data() {
      return {
        selectedMethod: 'EMAIL',
      }
    },
    computed: {
      maskedPhone() {
        const phone = this.mobile || ''
        if (!phone) return ''
        return phone.replace(/(\d{2})\d{5}(\d{2})/, '$1** *** *$2')
      },
      isHiddenZns() {
        const hour = new Date().getHours()
        return hour >= 22 || hour < 6
      },
    },
    mounted() {
      if (!this.mobile) {
        this.selectedMethod = 'EMAIL'
        this.handleContinue()
      }
    },
    methods: {
      async handleContinue() {
        try {
          this.updateShowLoading(true)
          const body = {
            id: this.id,
            type: 'TYPE_APPENDIX',
            isZns: this.selectedMethod === 'ZNS',
          }
          if (this.selectedMethod === 'EMAIL') {
            body.typeSend = this.selectedMethod
          }
          const response = await appendixContractNlGetOTP(body, this.token)
          if (response.code === 1000) {
            this.$emit('method', this.selectedMethod)
            this.$emit('next-step')
          } else {
            this.showFailMx(response.message ?? response.error)
          }
        } catch (error) {
          this.showFailMx(error.response?.data?.message ?? error.message)
        } finally {
          this.updateShowLoading(false)
        }
      },
    },
  }
</script>

<style scoped>
  .step-select-otp {
    display: flex;
    flex-direction: column;
  }

  .step-desc {
    font-size: 15px;
    color: #555;
    line-height: 1.6;
    margin-bottom: 20px;
  }

  /* Auth option */
  .auth-option {
    cursor: pointer;
    margin-bottom: 0;
  }

  .auth-option input[type='radio']:checked + .option-content {
    background: #eef4ff;
    border: 1.5px solid #0d6efd;
  }

  .option-content {
    border: 1.5px solid #e0e0e0;
    border-radius: 12px !important;
    transition:
      border-color 0.15s,
      background 0.15s;
  }

  .auth-option:hover .option-content {
    border-color: #aac4f5;
  }

  .auth-radio {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 2px solid #bbb;
    position: relative;
    transition: border-color 0.15s;
  }

  .auth-option input[type='radio']:checked + .option-content .auth-radio {
    border-color: #0d6efd;
  }

  .auth-option input[type='radio']:checked + .option-content .auth-radio::after {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    background: #0d6efd;
    border-radius: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .auth-icon-wrapper {
    width: 44px;
    height: 44px;
    background: #f4f6fb;
  }

  .auth-icon-wrapper img {
    width: 26px;
    height: 26px;
    object-fit: contain;
  }

  /* Fake footer */
  .popup-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 16px 0 0;
    border-top: 1px solid #e9ecef;
    margin-top: 8px;
  }

  .footer-btn {
    min-width: 110px;
    font-weight: 600;
    border-radius: 8px;
    padding: 8px 20px;
  }
</style>
